<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <v-select
            v-model="modelValue"
            :class="readonly ? 'custom-readonly' : ''"
            :items="items"
            :readonly="readonly"
            :variant="variant ?? useGlobalSetting().globalTextVariant"
            :label="label"
            :prepend-icon="prependIcon"
            :prepend-inner-icon="prependInnerIcon"
            :disabled="disabled"
            :density="density"
            :hide-details="hideDetails"
            :clearable="clearable"
        >
          <template v-slot:item="{ props: itemProps, item }">
            <v-list-item
                v-if="StatePermission[item.raw] <= permission"
                :subtitle="StateDescription[item.raw]"
                v-bind="itemProps"
            ></v-list-item>
          </template>
        </v-select>
      </div>
    </template>
    <span>Status</span>
  </v-tooltip>
</template>

<script lang="ts" setup>
import {Groups, State, StateDescription, StatePermission} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";

interface Props {
  variant?: any,
  readonly?: boolean,
  prependIcon?: string,
  prependInnerIcon?: string,
  permission?: number,
  disabled?: boolean,
  /** Kompakte Darstellung z.B. in Filterzeilen von Tabellen */
  density?: 'default' | 'comfortable' | 'compact',
  hideDetails?: boolean,
  clearable?: boolean,
  label?: string,
}

withDefaults(defineProps<Props>(), {
  readonly: false,
  prependIcon: "",
  prependInnerIcon: "",
  permission: Groups.tde.permission,
  disabled: false,
  density: 'default',
  hideDetails: false,
  clearable: false,
  label: "Status",
})

const modelValue = defineModel<State>();

const items = Object.entries(State).map(([key, value]) => value)
</script>
